<template>
  <div class="successful-submission">
    <div class="submission-container">
      <img
        :src="imageSrc"
        alt="Submission Confirmation"
        class="submission-image"
      />
      <h1 class="submission-title">
        Thank You <span class="highlight"> {{ applicantName }} </span><br />
        <span>{{ submissionSecondTitle }}</span>
      </h1>
      <p class="submission-message">
        {{ submissionMessage }}
      </p>
      <p class="submission-cta">
        {{ ctaText }} <span class="highlight">{{ ctaHighlight }}</span>
      </p>
      <v-btn class="explore-btn" size="large" @click="exploreMore">
        {{ buttonText }}
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SuccessfulSubmission',
  data() {
    return {
      applicantName: '',
      submissionSecondTitle: 'for Submitting Your Information!',
      imageSrc: require('@/assets/img/mailsubmit.svg'),
      submissionMessage: '',
      ctaText: '',
      ctaHighlight: '',
      buttonText: '',
      buttonLink: '',
    };
  },
  methods: {
    exploreMore() {
      this.$router.push(this.buttonLink);
    },
  },
  created() {
    // Retrieve query parameters from the route
    this.applicantName = this.$route.query.name || '';
    this.imageSrc =
      this.$route.query.imageSrc || require('@/assets/img/mailsubmit.svg');
      this.submissionSecondTitle = this.$route.query.secondTitle || 'for Submitting Your Information!',
    this.submissionMessage =
      this.$route.query.submissionMessage || this.submissionMessage;
    this.ctaText = this.$route.query.ctaText || this.ctaText;
    this.ctaHighlight = this.$route.query.ctaHighlight || this.ctaHighlight;
    this.buttonText = this.$route.query.buttonText || this.buttonText;
    this.buttonLink = this.$route.query.buttonLink || this.buttonLink;
    document.getElementById('loaderSection').classList.add('d-none');
  },
  mounted() {
    // Force scroll to top when the component is mounted
    window.scrollTo(0, 0);
  },
};
</script>

<style scoped>
.successful-submission {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  padding: 2rem;
  margin-bottom: 2rem;
}

.submission-container {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.submission-image {
  width: 100%;
  max-width: 300px;
  margin-bottom: 2rem;
}

.submission-title {
  font-size: 2rem;
  font-weight: 700;
  margin-bottom: 1rem;
  line-height: 1.2;
}

.submission-message {
  font-size: 1rem;
  color: #333;
  margin-bottom: 1.5rem;
  line-height: 1.5;
}

.submission-cta {
  font-size: 1rem;
  margin-bottom: 2rem;
}

.submission-cta .highlight {
  font-weight: 600;
}

.explore-btn {
  background: #007ab2;
  width: 200px;
  text-transform: capitalize;
  font-size: 1rem;
  padding: 0.5rem 2rem;
  border-radius: 8px;
  color: #fff !important;
}

.explore-btn:hover {
  background-color: #00aeff;
  color: white !important;
}

.highlight {
  color: #ff6860;
}

@media (max-width: 600px) {
  .submission-title {
    font-size: 1.5rem;
  }

  .submission-image {
    max-width: 200px;
  }

  .submission-message {
    font-size: 0.9rem;
  }
}
</style>
